/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teal_Green_Crab_LookInputs */

const en_teal_green_crab_look = /** @type {(inputs: Teal_Green_Crab_LookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classifying comments into topics using embeddings and AI.`)
};

const de_teal_green_crab_look = /** @type {(inputs: Teal_Green_Crab_LookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentare werden mithilfe von Embeddings und KI in Themen klassifiziert.`)
};

/**
* | output |
* | --- |
* | "Classifying comments into topics using embeddings and AI." |
*
* @param {Teal_Green_Crab_LookInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teal_green_crab_look = /** @type {((inputs?: Teal_Green_Crab_LookInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teal_Green_Crab_LookInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_teal_green_crab_look(inputs)
	return de_teal_green_crab_look(inputs)
});